export const staticHolidays = [
  '2024-05-24',
  '2024-03-03',
  '2024-05-01',
  '2024-03-04',
  '2024-05-06',
  '2024-09-06',
  '2024-09-23',
  '2024-12-26',
  '2024-12-24',
  '2024-05-04',
  '2024-12-25',
  '2024-01-01',
  '2024-05-03',
  '2024-05-05',
  '2025-05-24',
  '2025-03-03',
  '2025-05-01',
  '2025-05-26',
  '2025-05-06',
  '2025-04-20',
  '2025-09-08',
  '2025-04-21',
  '2025-09-06',
  '2025-12-26',
  '2025-12-24',
  '2025-04-19',
  '2025-04-18',
  '2025-12-25',
  '2025-01-01',
  '2026-04-10',
  '2026-05-24',
  '2026-03-03',
  '2026-04-12',
  '2026-05-01',
  '2026-09-22',
  '2026-12-28',
  '2026-05-06',
  '2026-09-07',
  '2026-09-06',
  '2026-04-11',
  '2026-12-26',
  '2026-12-24',
  '2026-04-13',
  '2026-01-01',
  '2026-12-25',
  '2026-05-25',

  '2027-05-02',
  '2027-03-03',
  '2027-12-27',
  '2027-05-01',
  '2027-05-24',
  '2027-09-22',
  '2027-12-28',
  '2027-05-06',
  '2027-04-30',
  '2027-09-06',
  '2027-12-26',
  '2027-12-24',
  '2027-01-01',
  '2027-12-25',
  '2027-05-03',

  '2028-03-03',
  '2028-05-24',
  '2028-05-08',
  '2028-05-01',
  '2028-04-16',
  '2028-04-14',
  '2028-05-06',
  '2028-04-17',
  '2028-01-03',
  '2028-12-26',
  '2028-09-06',
  '2028-12-27',
  '2028-04-15',
  '2028-12-24',
  '2028-12-25',
  '2028-01-01',

  '2029-03-03',
  '2029-03-05',
  '2029-05-24',
  '2029-04-09',
  '2029-05-01',
  '2029-04-06',
  '2029-09-24',
  '2029-05-06',
  '2029-05-07',
  '2029-12-26',
  '2029-09-06',
  '2029-04-08',
  '2029-12-24',
  '2029-04-07',
  '2029-12-25',
  '2029-01-01',
  '2030-04-27',
  '2030-12-26',
  '2030-12-24',
  '2030-04-26',
  '2030-09-06',
  '2030-04-28',
  '2030-01-01',
  '2030-12-25',
  '2030-03-03',
  '2030-05-24',
  '2030-05-01',
  '2030-03-04',
  '2030-09-22',
  '2030-05-06',
  '2030-04-29',
];
